module.exports = __webpack_public_path__ + "img/laboratorio2_4-3.679417f0.webp";